// ── CHILD TYPE PANELS ─────────────────────────────────────────────────────────
// Spec panels for assembly component types (Fabric, Trim, Hardware, Workroom,
// Roller Shades) plus the COM/COL panel.
// No business logic — pure presentation only.

import React from 'react';
import { IS, SHead, Row, Inp, Txta, Sel, Lbl } from './ui';

export const BLANK_COM = {manufacturer:"",collection:"",patternColorway:"",content:"",width:"",repeatH:"",repeatV:"",yardage:"",comInstructions:"",cutDirection:"",shipToName:"",shipToAttn:"",shipToAddress:"",shipToAddress2:"",shipToCity:"",shipToState:"",shipToZip:""};


export function FabricPanel(p) {
  var specs = p.specs || {};
  function s(k) { return function(v) { var n = Object.assign({}, specs); n[k] = v; p.onChange(n); }; }
  return (
    <div style={{ background: '#FAFAFA', border: '0.5px solid #E0E0DC', borderRadius: 8, padding: 14, marginBottom: 12 }}>
      <SHead>Fabric Specification</SHead>
      <Row>
        <div style={{ flex: 2 }}><Inp label="Content / Material" value={specs.content || ''} onChange={s('content')} placeholder="e.g. 100% Linen" /></div>
        <div style={{ flex: 1 }}><Inp label="Colorway" value={specs.colorway || ''} onChange={s('colorway')} placeholder="e.g. Ivory" /></div>
      </Row>
      <Row>
        <div style={{ flex: 1 }}><Inp label="Width" value={specs.width || ''} onChange={s('width')} placeholder='e.g. 54"' /></div>
        <div style={{ flex: 1 }}><Inp label="Repeat H" value={specs.repeatH || ''} onChange={s('repeatH')} placeholder='e.g. 13.5"' /></div>
        <div style={{ flex: 1 }}><Inp label="Repeat V" value={specs.repeatV || ''} onChange={s('repeatV')} placeholder='e.g. 13.5"' /></div>
      </Row>
      <Row>
        <div style={{ flex: 1 }}><Inp label="Yardage Required" value={specs.yardage || ''} onChange={s('yardage')} placeholder="e.g. 12 yd" /></div>
        <div style={{ flex: 1 }}><Inp label="Cut Direction" value={specs.cutDirection || ''} onChange={s('cutDirection')} placeholder="e.g. Railroaded" /></div>
      </Row>
      <Txta label="COM Instructions" value={specs.comInstructions || ''} onChange={s('comInstructions')} placeholder="e.g. Match repeat at center, cut double fullness..." rows={2} />
    </div>
  );
}

export function TrimPanel(p) {
  var specs = p.specs || {};
  function s(k) { return function(v) { var n = Object.assign({}, specs); n[k] = v; p.onChange(n); }; }
  return (
    <div style={{ background: '#FFFFFF', border: '0.5px solid #E0E0DC', borderRadius: 8, padding: 14, marginBottom: 12 }}>
      <SHead>Trim Specification</SHead>
      <Row>
        <div style={{ flex: 2 }}><Inp label="Content / Material" value={specs.content || ''} onChange={s('content')} placeholder="e.g. 100% Cotton gimp, brass nailhead" /></div>
        <div style={{ flex: 1 }}><Inp label="Colorway" value={specs.colorway || ''} onChange={s('colorway')} placeholder="e.g. Antique Gold" /></div>
      </Row>
      <Row>
        <div style={{ flex: 1 }}><Inp label="Width" value={specs.width || ''} onChange={s('width')} placeholder='e.g. 1.5"' /></div>
        <div style={{ flex: 1 }}><Inp label="Yardage Required" value={specs.yardage || ''} onChange={s('yardage')} placeholder="e.g. 8 yd" /></div>
      </Row>
      <Txta label="Trim Notes" value={specs.trimNotes || ''} onChange={s('trimNotes')} placeholder="e.g. 1.5in brass nailhead, apply to base of panel..." rows={2} />
    </div>
  );
}

export function HardwarePanel(p) {
  var specs = p.specs || {};
  function s(k) { return function(v) { var n = Object.assign({}, specs); n[k] = v; p.onChange(n); }; }
  function tog(k, label, vals, color) {
    var ac = color || '#388e3c';
    var bg = color === '#1565c0' ? '#e3f2fd' : '#e8f5e9';
    return (
      <div style={{ marginBottom: 12 }}>
        <Lbl>{label}</Lbl>
        <div style={{ display: 'flex', gap: 8 }}>
          {vals.map(function(opt) {
            var on = (specs[k] || '') === opt;
            return (
              <button
                key={opt}
                onClick={function() { s(k)(opt); }}
                style={{
                  padding: '4px 12px',
                  borderRadius: 6,
                  border: '1px solid ' + (on ? ac : '#ddd'),
                  background: on ? bg : '#fff',
                  fontWeight: on ? 700 : 400,
                  fontSize: 12,
                  cursor: 'pointer',
                  color: on ? ac : '#555',
                }}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>
    );
  }
  var isRod = (specs.hwType || '') === 'Rod';
  var isTrack = (specs.hwType || '') === 'Track';
  return (
    <div style={{ background: '#FFFFFF', border: '0.5px solid #E0E0DC', borderRadius: 8, padding: 14, marginBottom: 12 }}>
      <SHead>Hardware Specification</SHead>
      {tog('hwType', 'Type', ['Track', 'Rod', 'Wire', 'Other'])}
      <Row>
        <div style={{ flex: 1 }}><Inp label="Finish" value={specs.finish || ''} onChange={s('finish')} placeholder="e.g. Satin Nickel" /></div>
        <div style={{ flex: 1 }}><Inp label="Length" value={specs.length || ''} onChange={s('length')} placeholder='e.g. 96"' /></div>
      </Row>
      {tog('wand', 'Wand', ['Yes', 'No'])}
      {isRod && (
        <Row>
          <div style={{ flex: 1 }}><Inp label="Diameter" value={specs.diameter || ''} onChange={s('diameter')} placeholder='e.g. 1.5"' /></div>
          <div style={{ flex: 1 }}><Inp label="Rings" value={specs.rings || ''} onChange={s('rings')} placeholder="e.g. 24" /></div>
        </Row>
      )}
      {isRod && tog('finials', 'Finials', ['Yes', 'No'])}
      {isTrack && (
        <Row>
          <div style={{ flex: 1 }}>
            <Sel label="Motor Brand" value={specs.motorBrand || ''} onChange={s('motorBrand')}>
              <option value="">— Select —</option>
              {['Lutron', 'Somfy'].map(function(o) { return <option key={o} value={o}>{o}</option>; })}
            </Sel>
          </div>
          <div style={{ flex: 1 }}><Inp label="Motor Model / SKU" value={specs.motorModel || ''} onChange={s('motorModel')} placeholder="e.g. Lutron Sivoia QS" /></div>
        </Row>
      )}
      <Txta label="Hardware Notes" value={specs.hardwareNotes || ''} onChange={s('hardwareNotes')} placeholder="Mount height, bracket count, special instructions..." rows={2} />
    </div>
  );
}

export function WorkroomPanel(p) {
  var specs = p.specs || {};
  var siblings = p.siblings || [];
  function s(k) { return function(v) { var n = Object.assign({}, specs); n[k] = v; p.onChange(n); }; }
  var fabricSib = siblings.find(function(c) { return c.childType === 'Fabric'; });
  var trimSib = siblings.find(function(c) { return c.childType === 'Trim'; });
  var fabricRef = fabricSib ? (
    <div style={{ background: '#F8F8F6', border: '0.5px solid #E0E0DC', borderRadius: 6, padding: '8px 12px', marginBottom: 6, fontSize: 12 }}>
      <div style={{ fontWeight: 700, color: '#111', marginBottom: 3 }}>Fabric</div>
      <div>{(fabricSib.vendor || '') + (fabricSib.item ? ' — ' + fabricSib.item : '')}</div>
      {fabricSib.specs && fabricSib.specs.content && <div style={{ color: '#888' }}>{fabricSib.specs.content}</div>}
    </div>
  ) : null;
  var trimRef = trimSib ? (
    <div style={{ background: '#FFFFFF', border: '0.5px solid #E0E0DC', borderRadius: 6, padding: '8px 12px', marginBottom: 6, fontSize: 12 }}>
      <div style={{ fontWeight: 500, color: '#111111', marginBottom: 3 }}>Trim</div>
      <div>{(trimSib.vendor || '') + (trimSib.item ? ' — ' + trimSib.item : '')}</div>
      {trimSib.specs && trimSib.specs.content && <div style={{ color: '#888' }}>{trimSib.specs.content}</div>}
    </div>
  ) : null;
  return (
    <div style={{ background: '#FFFFFF', border: '0.5px solid #E0E0DC', borderRadius: 8, padding: 14, marginBottom: 12 }}>
      <SHead>Workroom Specification</SHead>
      {(fabricRef || trimRef) && (
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#888', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: 6 }}>Materials Sent to Workroom</div>
          {fabricRef}
          {trimRef}
        </div>
      )}
      <Row>
        <div style={{ flex: 1 }}>
          <Sel label="Pleat Type" value={specs.pleat || ''} onChange={s('pleat')}>
            <option value="">— Select —</option>
            {['Ripple Fold', 'Pinch Pleat', 'Goblet', 'Box Pleat', 'Eyelet', 'Unpleated (Flat Panel)'].map(function(o) { return <option key={o} value={o}>{o}</option>; })}
          </Sel>
        </div>
        <div style={{ flex: 1 }}>
          <Sel label="Draw" value={specs.draw || ''} onChange={s('draw')}>
            <option value="">— Select —</option>
            {['Left', 'Right', 'Center', 'Stationary'].map(function(o) { return <option key={o} value={o}>{o}</option>; })}
          </Sel>
        </div>
      </Row>
      <Row>
        <div style={{ flex: 1 }}>
          <Sel label="Mount" value={specs.mountType || ''} onChange={s('mountType')}>
            <option value="">— Select —</option>
            {['Inside Mount', 'Outside Mount', 'Ceiling Mount'].map(function(o) { return <option key={o} value={o}>{o}</option>; })}
          </Sel>
        </div>
        <div style={{ flex: 1 }}>
          <Sel label="Lining" value={specs.lining || ''} onChange={s('lining')}>
            <option value="">— Select —</option>
            {['Unlined', 'Lined', 'Blackout', 'Interlining', 'Interlining + Blackout'].map(function(o) { return <option key={o} value={o}>{o}</option>; })}
          </Sel>
        </div>
      </Row>
      <Row>
        <div style={{ flex: 1 }}>
          <Sel label="Fabric Orientation" value={specs.fabricOrientation || ''} onChange={s('fabricOrientation')}>
            <option value="">— Select —</option>
            {['Up the Bolt', 'Railroaded'].map(function(o) { return <option key={o} value={o}>{o}</option>; })}
          </Sel>
        </div>
        <div style={{ flex: 1 }}>
          <div>
            <Lbl>Motorized</Lbl>
            <div style={{ display: 'flex', gap: 8 }}>
              {['Yes', 'No'].map(function(opt) {
                var on = (specs.motorized || '') === opt;
                return (
                  <button
                    key={opt}
                    onClick={function() { s('motorized')(opt); }}
                    style={{
                      padding: '5px 14px',
                      borderRadius: 6,
                      border: '1.5px solid ' + (on ? '#111' : '#D0D0CC'),
                      background: on ? '#111' : '#fff',
                      fontWeight: 500,
                      fontSize: 12,
                      cursor: 'pointer',
                      color: on ? '#fff' : '#555',
                    }}
                  >
                    {opt}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </Row>
      <Row>
        <div style={{ flex: 1 }}><Inp label="Finished Width" value={specs.finishedWidth || ''} onChange={s('finishedWidth')} placeholder='e.g. 96"' /></div>
        <div style={{ flex: 1 }}><Inp label="Finished Length / Drop" value={specs.finishedLength || ''} onChange={s('finishedLength')} placeholder='e.g. 108"' /></div>
      </Row>
      <Row>
        <div style={{ flex: 1 }}><Inp label="Number of Panels" value={specs.numPanels || ''} onChange={s('numPanels')} placeholder="e.g. 2" /></div>
        <div style={{ flex: 1 }}><Inp label="Fullness (%)" value={specs.fullness || ''} onChange={s('fullness')} placeholder="e.g. 250" /></div>
      </Row>
      <Txta label="Workroom Notes" value={specs.workroomNotes || ''} onChange={s('workroomNotes')} placeholder="Fabrication scope, finish details, special instructions..." rows={3} />
    </div>
  );
}

export function RollerShadePanel(p) {
  var specs = p.specs || {};
  function s(k) { return function(v) { var n = Object.assign({}, specs); n[k] = v; p.onChange(n); }; }
  function tog(k, label, vals) {
    return (
      <div style={{ marginBottom: 12 }}>
        <Lbl>{label}</Lbl>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {vals.map(function(opt) {
            var on = (specs[k] || '') === opt;
            return (
              <button
                key={opt}
                onClick={function() { s(k)(opt); }}
                style={{
                  padding: '4px 12px',
                  borderRadius: 6,
                  border: '1px solid ' + (on ? '#1565c0' : '#ddd'),
                  background: on ? '#e3f2fd' : '#fff',
                  fontWeight: on ? 700 : 400,
                  fontSize: 12,
                  cursor: 'pointer',
                  color: on ? '#0d47a1' : '#555',
                }}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>
    );
  }
  return (
    <div style={{ background: '#FFFFFF', border: '0.5px solid #E0E0DC', borderRadius: 8, padding: 14, marginBottom: 12 }}>
      <SHead>Roller Shade Specification</SHead>
      {tog('opacity', 'Opacity', ['Sheer', 'Light Filtering', 'Room Darkening', 'Blackout'])}
      <Row>
        <div style={{ flex: 1 }}><Inp label="Finished Width" value={specs.finishedWidth || ''} onChange={s('finishedWidth')} placeholder='e.g. 48"' /></div>
        <div style={{ flex: 1 }}><Inp label="Finished Length" value={specs.finishedLength || ''} onChange={s('finishedLength')} placeholder='e.g. 84"' /></div>
      </Row>
      {tog('rollDirection', 'Roll Direction', ['Regular', 'Reverse'])}
      {tog('motor', 'Motor', ['Yes', 'No'])}
      {specs.motor === 'Yes' && (
        <Row>
          <div style={{ flex: 1 }}>
            <Sel label="Motor Brand" value={specs.motorBrand || ''} onChange={s('motorBrand')}>
              <option value="">— Select —</option>
              {['Lutron', 'Somfy'].map(function(o) { return <option key={o} value={o}>{o}</option>; })}
            </Sel>
          </div>
          <div style={{ flex: 1 }}>{tog('power', 'Power', ['Battery', 'Hardwired'])}</div>
        </Row>
      )}
      {tog('fascia', 'Fascia', ['Yes', 'No'])}
      <Inp label="Hem Bar Style" value={specs.hemBarStyle || ''} onChange={s('hemBarStyle')} placeholder="e.g. Flat aluminum" />
      {tog('chainSide', 'Chain Side', ['Left', 'Right'])}
      <Txta label="Shade Notes" value={specs.shadeNotes || ''} onChange={s('shadeNotes')} placeholder="Special instructions..." rows={2} />
    </div>
  );
}
